import * as React from 'react'
import { useState } from 'react'


const Context = React.createContext({})
const today = new Date()

export function CommonFiltersItemsContextProvider({ defaultValues={}, children }) {
    if (defaultValues?.customDateRange) {
        defaultValues.customDateRange = defaultValues.customDateRange.map(d => new Date(d))
    }

	const initialFilterState = {
		hotels: [], hotelChain: '', allHotels: [], currency: 'EUR',
		customDateRange: [today, today], mappingType: 'hotel', customDate: today, lastDate: null,
		boardID: null, rateID: null, providerID: [], roomID: [], rawRooms: [], sites: null, siteLocation: [], minStay: false,
		nights: null, noNights: false, nightsStatic: null, adults: 2, kids: 0, priceType: null, open: false, devices: [1],
		payType: null, action: 'globalPosition', maxDate: 0, occupancy: '', sitesList: [], sources: [], connectivities: [],
		siteName: '', cityFrom: null, cityTo: null, cityFromName: '', cityToName: '', hotelName: '', location: null,
		hotelHistorical: [], year: [], otherSites: null, elementsOtherSites: [], devicesStatic: 1, province: [],
		specificDays: [], calendarType: null, sitesListRealTime: [], hotelsRealTime: [], totalSites: null,
		dateRange:null, realtimeMarket: null, idMainHotelCustomPinned: null, excludedHotels: [], ...defaultValues
	}

	const [state, setState] = useState(initialFilterState)

	return <Context.Provider value={{ state, setState, initialFilterState }}>
		{children}
	</Context.Provider>
}

export default Context